// extracted by mini-css-extract-plugin
var _1 = "PrefixTriggeredMenu-module__container--B1sol";
var _2 = "PrefixTriggeredMenu-module__reference--mZpTw";
var _3 = "PrefixTriggeredMenu-module__small--bSzDk";
export { _1 as "container", _2 as "reference", _3 as "small" }
